import { createEnumMap } from 'Commons/helpers/utils/Formatter';

const DISPLAY = createEnumMap(['Unread', 'Read', 'NA']);

export { DISPLAY };
